// Shared UI helpers: semantic badges for Impact / Applicability / Provenance.
import React from "react";

export const IMPACT = {
  Critico: { text: "#991B1B", bg: "#FEE2E2", border: "#FCA5A5", dot: "#DC2626" },
  Alto: { text: "#9A3412", bg: "#FFEDD5", border: "#FDBA74", dot: "#EA580C" },
  Medio: { text: "#92400E", bg: "#FEF3C7", border: "#FDE68A", dot: "#D97706" },
  Basso: { text: "#166534", bg: "#DCFCE7", border: "#86EFAC", dot: "#16A34A" },
  Informativo: { text: "#1E40AF", bg: "#DBEAFE", border: "#93C5FD", dot: "#2563EB" },
};

export const PROVENANCE = {
  FACT: { bg: "#E0F2FE", text: "#0369A1", border: "#7DD3FC" },
  REQUIREMENT: { bg: "#FEE2E2", text: "#991B1B", border: "#FCA5A5" },
  GUIDANCE: { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  EVIDENCE: { bg: "#DCFCE7", text: "#166534", border: "#86EFAC" },
  INTERPRETATION: { bg: "#F3E8FF", text: "#6B21A8", border: "#D8B4FE" },
  RECOMMENDATION: { bg: "#ECFEFF", text: "#155E75", border: "#67E8F9" },
};

export function ImpactBadge({ level, small, testid }) {
  const c = IMPACT[level] || IMPACT.Informativo;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full font-semibold"
      style={{ color: c.text, background: c.bg, border: `1px solid ${c.border}`,
        padding: small ? "1px 8px" : "3px 10px", fontSize: small ? "0.7rem" : "0.75rem" }}>
      <span style={{ width: 7, height: 7, borderRadius: 99, background: c.dot }} />
      {level}
    </span>
  );
}

export function RelevanceBar({ score }) {
  const color = score >= 80 ? "#16A34A" : score >= 55 ? "#D97706" : score >= 30 ? "#EA580C" : "#94A3B8";
  return (
    <div className="flex items-center gap-2 min-w-[110px]">
      <div className="flex-1 h-2 rounded-full bg-slate-200 overflow-hidden">
        <div style={{ width: `${score}%`, background: color }} className="h-full rounded-full transition-all" />
      </div>
      <span className="font-mono text-xs font-semibold" style={{ color }}>{score}%</span>
    </div>
  );
}

export const APPL_COLOR = {
  "Diretta": "#166534", "Probabile": "#15803D", "Possibile": "#D97706",
  "Improbabile": "#64748B", "Non applicabile": "#94A3B8", "Da valutare": "#2563EB",
};

export function Pill({ children, color = "#334155", bg = "#F1F5F9", testid }) {
  return (
    <span data-testid={testid} className="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium"
      style={{ color, background: bg }}>{children}</span>
  );
}

export function SourceLevelTag({ level }) {
  return (
    <span className="font-mono text-[0.68rem] px-1.5 py-0.5 rounded bg-slate-100 text-slate-500 border border-slate-200">
      Fonte L{level}
    </span>
  );
}
